import React, { createContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ajax } from '../../utils/web/webUtils.js';
import { createAlert } from '../standaloneComponents.js';
import Login from '../login/login.js';
import Loading from '../loading/loading.js';
import './loginProvider.scss';
export var LoginContext = /*#__PURE__*/createContext({
  loggedIn: null,
  logInWindowOpen: false,
  user: null
});

function LoginProvider(props) {
  let {
    children,
    requireLogin = true,
    skipLoginPaths = [],
    useOauth2Login = false
  } = props;
  let [loggedIn, setLoggedIn] = useState(null);
  let [logInWindowOpen, setLogInWindowOpen] = useState(false);
  let [user, setUser] = useState(null);
  let navigate = useNavigate();
  let isSkippedPath = false;

  if (skipLoginPaths?.length) {
    isSkippedPath = skipLoginPaths.some(path => location.pathname.startsWith(path));
  }

  let shouldRequireLogin = requireLogin && !isSkippedPath;
  useEffect(() => {
    if (shouldRequireLogin) {
      ajax({
        endPoint: '/checkLoggedIn'
      }).then(results => {
        if (!results.result && window.location.pathname !== '/') {
          navigate('/');
        }

        setLoggedIn(results.result);
        setUser(results.user);
      });
    }
  }, []);

  let login = async (username, password) => {
    if (useOauth2Login) {
      let results = await ajax({
        endPoint: '/login'
      });
      console.log(results);

      if (results.result) {
        location.href = results.redirectTo;
      }
    } else {
      let results = await ajax({
        endPoint: '/login',
        data: {
          username,
          password
        }
      });

      if (!results.result) {
        createAlert(results.desc);
      }

      setLoggedIn(results.result);
      setUser(results.user);

      if (logInWindowOpen) {
        setLogInWindowOpen(false);
      }
    }
  };

  let logout = async () => {
    let results = await ajax({
      endPoint: '/logout'
    });

    if (results.result) {
      navigate('/');
    }

    setLoggedIn(!results.result);
    setUser(null);
  };

  let showLogInWindow = () => setLogInWindowOpen(true);

  if (shouldRequireLogin && loggedIn === null) {
    return /*#__PURE__*/React.createElement(Loading, {
      type: "fixed"
    });
  } else if (shouldRequireLogin && !loggedIn) {
    return /*#__PURE__*/React.createElement(Login, {
      login: login,
      useOauth2Login: useOauth2Login
    });
  } else {
    return /*#__PURE__*/React.createElement(LoginContext.Provider, {
      value: {
        login,
        logout,
        loggedIn,
        logInWindowOpen,
        setLogInWindowOpen,
        user,
        showLogInWindow
      }
    }, children);
  }
}

export default LoginProvider;